import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../services/shared/shared.service';
import { ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ForuscareService } from '../../services/foruscare/foruscare.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {

  viewHeight: number;
  userInfo: any;
  menuList = {
    dashboard: true,
    telecareDashboard: false,
    accounts: false,
    serviceProviders: false,
    adminUsers: false,
    workflowSettings: false,
    devices: false,
    frameworkSettings: false,
    screeningEvents: false,
    appointments: false,
    fieldCustomization: false,
    exportExcel:false,
    icdCodes: false,
    apiKeys: false,
    priceConfiguration: false,
    packages: false,
    packagesValidity: false,
    validityExtension: false,
    transactionHistory: false,
    paymentStatistics: false,
    providerConfigurations: false,
    incentiveConfig: false,
    incentiveReport: false,
    spectacleHome: false
  };
  activeMenu = 'dashboard';
  showDHPMenu: Boolean = true;
  showTelecareMenu: Boolean = false;

  constructor(public sharedService: SharedService, public foruscareService: ForuscareService, public elementRef: ElementRef, public router: Router) { }

  ngOnInit() {
    if (this.sharedService.appMenuFolded) {
      this.sharedService.appMenuFolded.subscribe(menufolded => {
        let navHeight;
        if (menufolded) {
          var navHeightElement = document.querySelector('#main-content section.wrapper .content-wrapper');
          if (navHeightElement != null) { navHeight = navHeightElement.scrollHeight + 90; }
          document.getElementById("teMenu").innerHTML = "TE";
          document.getElementById("dhpMenu").innerHTML = "DHP";
        } else {
          navHeight = window.innerHeight - 60;
          document.getElementById("teMenu").innerHTML = "TeleEye";
          document.getElementById("dhpMenu").innerHTML = "Digital Health Platform";
        }
        document.querySelector('#main-menu-wrapper')['style'].height = navHeight;
      });
    }

    if (this.sharedService.userInfoMessage) {
      this.sharedService.userInfoMessage.subscribe(userinfo => {
        this.userInfo = userinfo;
      });
    }
  }

  navigateToTemplate(path: string): void {
    this.router.navigate([path]);
  }

  markNewActiveMenu(newActiveMenu: string): void {
    if (this.activeMenu !== newActiveMenu) {
      this.menuList[this.activeMenu] = false;
      this.menuList[newActiveMenu] = true;
      this.activeMenu = newActiveMenu;
    }
  }

  getRoleName(key) {
    return this.foruscareService.getRoleNameUsingKey(key);
  }

  expandList(event) {
    const elementsLink = document.querySelectorAll('.navlink');
    if (elementsLink != null && elementsLink.length > 0) {
      for (let i = 0; i < elementsLink.length; i++) {
        while (elementsLink[i].parentElement.classList.contains('active')) {
          elementsLink[i].parentElement.classList.remove('active');
        }
      }
    }

    const elements = document.querySelectorAll('.menulist');

    if (elements != null && elements.length > 0) {
      for (let i = 0; i < elements.length; i++) {
        if (elements[i] != event.target.parentElement.parentElement) {
          while (elements[i].classList.contains('active')) {
            elements[i].classList.remove('active');
          }
        }
      }
    }

    if (!event.target.parentElement.parentElement.classList.contains('active')) {
      event.target.parentElement.parentElement.classList.add('active');
    } else {
      event.target.parentElement.parentElement.classList.remove('active');
    }
  }

  // ngAfterViewInit() {
  // }

}
